/*
 * DeliveryDateTime Messages
 *
 * This contains all the text for the DeliveryDateTime container.
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.containers.DeliveryDateTime';

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: 'Thời gian giao hàng!',
  },
  note: {
    id: `${scope}.note`,
    defaultMessage: 'Lưu ý:',
  },
  specialDateNote: {
    id: `${scope}.specialDateNote`,
    defaultMessage:
      'Để chủ động nguồn hàng dịp Lễ, quý khách vui lòng chọn giờ giao hàng sớm hơn.',
  },
  tetDateNote: {
    id: `${scope}.tetDateNote`,
    defaultMessage:
      'Vui lòng chọn giờ giao sớm hơn trong dịp Tết. Trong trường hợp không thể giao đủ hàng, KAMEREO sẽ liên hệ quý khách.',
  },
  specialDateSubNote: {
    id: `${scope}.specialDateSubNote`,
    defaultMessage: 'Thời gian giao hàng sẽ trở lại bình thường trong đơn tiếp theo.',
  },
  holidayNote: {
    id: `${scope}.holidayNote`,
    defaultMessage: 'Ngày lễ',
  },
});
